/**
 * A tab left open keeps running the version it loaded (Liam's Plan my day kept the old, non-saving page all day).
 * Every 5 minutes, and when the tab comes back into view, the shell asks which version is live; when it differs it
 * offers a reload. Nothing reloads by itself, so nothing being typed is lost.
 */
import { RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";

declare const __ONE_VERSION__: string;

export function UpdateBar() {
  const [live, setLive] = useState<string | null>(null);
  useEffect(() => {
    const check = () => fetch("/api/health", { cache: "no-store" }).then((r) => r.json()).then((b: { version?: string }) => b.version && setLive(b.version)).catch(() => undefined);
    void check();
    const t = setInterval(check, 5 * 60_000);
    const onShow = () => document.visibilityState === "visible" && void check();
    document.addEventListener("visibilitychange", onShow);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onShow); };
  }, []);
  if (!live || live === __ONE_VERSION__) return null;
  return (
    <div className="fixed inset-x-0 bottom-4 z-40 flex justify-center px-4" role="status">
      <div className="flex items-center gap-3 rounded-xl border border-[var(--line)] bg-[var(--surface,#fff)] px-4 py-2.5 text-sm shadow-lg">
        <span>ONE was updated ({live}).</span>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => location.reload()}><RefreshCw size={13} /> Reload</button>
      </div>
    </div>
  );
}
